function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  "data-name": "Warstwa 2"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Warstwa 1"
}, /*#__PURE__*/React.createElement("rect", {
  width: 48,
  height: 48,
  rx: 5,
  ry: 5,
  fill: "#94000f"
}), /*#__PURE__*/React.createElement("path", {
  d: "M19.41 27.54L24 23.16l4.59 4.38L30 26.19l-6-5.74-6 5.74z",
  fill: "#fff"
})));

function SvgScrollup(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 48 48"
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA0OCA0OCI+PGRlZnM+PHN0eWxlPi5jbHMtMXtmaWxsOiM5NDAwMGY7fS5jbHMtMntmaWxsOiNmZmY7fTwvc3R5bGU+PC9kZWZzPjx0aXRsZT5aYXPDs2IgMTwvdGl0bGU+PGcgaWQ9IldhcnN0d2FfMiIgZGF0YS1uYW1lPSJXYXJzdHdhIDIiPjxnIGlkPSJXYXJzdHdhXzEtMiIgZGF0YS1uYW1lPSJXYXJzdHdhIDEiPjxyZWN0IGlkPSJCdXR0b24iIGNsYXNzPSJjbHMtMSIgd2lkdGg9IjQ4IiBoZWlnaHQ9IjQ4IiByeD0iNSIgcnk9IjUiLz48cGF0aCBpZD0iQXJyb3ciIGNsYXNzPSJjbHMtMiIgZD0iTTE5LjQxLDI3LjU0LDI0LDIzLjE2bDQuNTksNC4zOEwzMCwyNi4xOWwtNi01Ljc0LTYsNS43NFoiLz48L2c+PC9nPjwvc3ZnPg==";
export { SvgScrollup as ReactComponent };